<template>
  <div class="login-container container-fluid p-0 m-0 justify-content-center d-flex flex-column align-items-center">
    <div class="row w-100">
      <div class="col-xl-4 offset-xl-4 col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-sm-10 offset-sm-1 col-10 offset-1">
        <div class="cotizarlo-general-wrapper">
          <div class="card-body px-xl-5 px-lg-5 px-md-5 px-sm-3 px-2 pt-xl-5 pt-lg-5 pt-md-5 pt-sm-3 pt-2 pb-4">
            <form>
              <div class="row">
                <div class="col-8 offset-2 text-center">
                  <img src="@/assets/logo.svg" class="img-fluid" style="max-height:50px !important;"/>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-12 text-center">
                  <strong>Reestablece tu contraseña:</strong>
                </div>
              </div>
              <div class="row mt-4">
                <div class="col">
                  <div class="form-group">
                    <div class="input-field login" :class="{ 'is-invalid': $v.password.$error }">
                      <i class="icon-input icon-cot-bloqueado"></i>
                      <input type="password" class="main-input icon" id="password" v-model="password" placeholder="Nueva contraseña" autocomplete="new_password"/>
                      <label class="main-label icon" for="password">Contraseña*</label>
                    </div>
                    <small class="form-text text-danger" v-show="!$v.password.minLength">La contraseña debe ser de al menos 6 caractéres</small
                    >
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <div class="input-field login" :class="{ 'is-invalid': $v.password_confirmation.$error }">
                      <i class="icon-input icon-cot-bloqueado"></i>
                      <input type="password" class="main-input icon" id="password_confirmation" v-model="password_confirmation" placeholder="Verificar contraseña" autocomplete="new_password_confirmation"/>
                      <label class="main-label icon" for="password">Contraseña*</label>
                    </div>
                    <small class="form-text text-danger" v-show="$v.password.minLength && !$v.password_confirmation.sameAsPassword">No coincide la contraseña</small>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <button
                    type="submit"
                    class="btn form-control cot-login-btn"
                    @click.prevent="resetPassword"
                  >
                    ¡Listo! Iniciar sesión
                  </button>
                </div>
              </div>

              <div class="row">
                <div class="col text-center">
                  <router-link :to="{ name: 'login' }" tag="a">
                    <small class="text-muted" style="color: #808285"
                      >¡Ya me acordé! Login</small
                    >
                  </router-link>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col text-center">
                  <router-link :to="{ name: 'clientRegister' }" tag="a">
                    <small class="text-muted" style="font-weight: 700"
                      >¿No tienes cuenta? Crea una aquí</small
                    >
                  </router-link>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required, minLength, sameAs } from "vuelidate/lib/validators";
export default {
  mixins: [validationMixin],
  beforeMount() {
    if (this.$route.query.token == undefined) {
      this.$store.dispatch("showMessage", {
        action: "error",
        message: "La ruta proporcionada no es válida",
      });
      this.$router.push({ name: "login" });
    } else {
      this.passwordToken = this.$route.query.token;
      this.email = this.$route.query.email;
    }
  },
  data() {
    return {
      password: null,
      password_confirmation: null,
      passwordToken: null,
      email:null
    };
  },
  validations: {
    password: { required, minLength: minLength(6) },
    password_confirmation: { required, sameAsPassword: sameAs("password") },
  },
  methods: {
    resetPassword() {
      if (this.$v.$invalid) {
        this.$store.dispatch("showMessage", {
          action: "error",
          message: "Por favor revisa todos los campos",
        });
      }else{
        this.$store.dispatch('showLoader',{show:true});
        this.$store.dispatch('client/resetPassword',this.$data).then(
          () => {
            this.$store.dispatch("showMessage", {
              action: "success",
              message: "Contraseña reestablecida correctamente",
            }); 
            this.$router.push({name:'login'})
            
          }
        );
        
      }
    },
  },
};
</script>